import {
  LogoApacheKafkaImage,
  LogoApolloImage,
  LogoAWSImage,
  LogoAWSSNSImage,
  LogoAWSSQSImage,
  LogoCircleCIImage,
  LogoClaudeAIImage,
  LogoDeepgramImage,
  LogoDockerImage,
  LogoFigmaImage,
  LogoGoogleAnalyticsImage,
  LogoGrafanaImage,
  LogoHardHatImage,
  LogoHerokuImage,
  LogoHuggingFaceImage,
  LogoKotlinImage,
  LogoKubernetesImage,
  LogoLangchainImage,
  LogoMistralImage,
  LogoNewRelicImage,
  LogoNextJSImage,
  LogoNodeJSImage,
  LogoOneSignalImage,
  LogoOpenAIImage,
  LogoOpenZeppelinImage,
  LogoPineconeImage,
  LogoPostgreSQLImage,
  LogoPrometheusImage,
  LogoRabbitMQImage,
  LogoReactImage,
  LogoRedisImage,
  LogoSentryImage,
  LogoSolidityImage,
  LogoStorybookJSImage,
  LogoSwiftImage,
  LogoWeb3JSImage,
} from 'Assets/Image/TechLogos'

import { TechWeBuildOnTiWinId, TechWeBuildOnTiWinItem } from './types'

export const TECH_WE_BUILD_ON_TI_WIN_ITEMS: TechWeBuildOnTiWinItem[] = [
  {
    id: TechWeBuildOnTiWinId.Frontend,
    title: 'Frontend',
    technologies: [
      { id: 'React', title: 'React', logo: LogoReactImage },
      { id: 'Next.js', title: 'Next.js', logo: LogoNextJSImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.Mobile,
    title: 'Mobile',
    technologies: [
      { id: 'React Native', title: 'React Native', logo: LogoReactImage },
      { id: 'Swift', title: 'Swift', logo: LogoSwiftImage },
      { id: 'Kotlin', title: 'Kotlin', logo: LogoKotlinImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.Backend,
    title: 'Backend',
    technologies: [
      { id: 'Node.js', title: 'Node.js', logo: LogoNodeJSImage },
      {
        id: 'Apollo GraphQL',
        title: 'Apollo GraphQL',
        logo: LogoApolloImage,
      },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.InfrastructureDevOps,
    title: 'Infrastructure & DevOps',
    technologies: [
      { id: 'AWS', title: 'AWS', logo: LogoAWSImage },
      { id: 'Heroku', title: 'Heroku', logo: LogoHerokuImage },
      { id: 'Docker', title: 'Docker', logo: LogoDockerImage },
      { id: 'Kubernetes', title: 'Kubernetes', logo: LogoKubernetesImage },
      { id: 'CircleCI', title: 'CircleCI', logo: LogoCircleCIImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.RealTimeMessaging,
    title: 'Real-Time & Messaging',
    technologies: [
      { id: 'Apache Kafka', title: 'Apache Kafka', logo: LogoApacheKafkaImage },
      { id: 'RabbitMQ', title: 'RabbitMQ', logo: LogoRabbitMQImage },
      { id: 'AWS SQS', title: 'AWS SQS', logo: LogoAWSSQSImage },
      { id: 'AWS SNS', title: 'AWS SNS', logo: LogoAWSSNSImage },
      { id: 'OneSignal', title: 'OneSignal', logo: LogoOneSignalImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.Databases,
    title: 'Databases',
    technologies: [
      { id: 'PostgreSQL', title: 'PostgreSQL', logo: LogoPostgreSQLImage },
      { id: 'Redis', title: 'Redis', logo: LogoRedisImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.AiMl,
    title: 'AI / ML',
    technologies: [
      { id: 'OpenAI', title: 'OpenAI', logo: LogoOpenAIImage },
      { id: 'Langchain', title: 'Langchain', logo: LogoLangchainImage },
      { id: 'Deepgram', title: 'Deepgram', logo: LogoDeepgramImage },
      { id: 'Mistral', title: 'Mistral', logo: LogoMistralImage },
      {
        id: 'Claude AI (Anthropic)',
        title: 'Claude AI (Anthropic)',
        logo: LogoClaudeAIImage,
      },
      { id: 'Hugging Face', title: 'Hugging Face', logo: LogoHuggingFaceImage },
      { id: 'Pinecone', title: 'Pinecone', logo: LogoPineconeImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.BlockchainWeb3,
    title: 'Blockchain / Web3',
    technologies: [
      { id: 'Solidity', title: 'Solidity', logo: LogoSolidityImage },
      { id: 'Web3.js', title: 'Web3.js', logo: LogoWeb3JSImage },
      { id: 'Hardhat', title: 'Hardhat', logo: LogoHardHatImage },
      {
        id: 'OpenZeppelin',
        title: 'OpenZeppelin',
        logo: LogoOpenZeppelinImage,
      },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.DesignPrototyping,
    title: 'Design & Prototyping',
    technologies: [
      { id: 'Figma', title: 'Figma', logo: LogoFigmaImage },
      { id: 'Storybook.js', title: 'Storybook.js', logo: LogoStorybookJSImage },
    ],
  },
  {
    id: TechWeBuildOnTiWinId.Monitoring,
    title: 'Monitoring',
    technologies: [
      { id: 'NewRelic', title: 'NewRelic', logo: LogoNewRelicImage },
      { id: 'Sentry', title: 'Sentry', logo: LogoSentryImage },
      { id: 'Prometheus', title: 'Prometheus', logo: LogoPrometheusImage },
      { id: 'Grafana', title: 'Grafana', logo: LogoGrafanaImage },
      {
        id: 'Google Analytics',
        title: 'Google Analytics',
        logo: LogoGoogleAnalyticsImage,
      },
    ],
  },
]
